/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sources_ConnectInputs */

const es_settings_sources_connect = /** @type {(inputs: Settings_Sources_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar`)
};

const en_settings_sources_connect = /** @type {(inputs: Settings_Sources_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect`)
};

/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Settings_Sources_ConnectInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_sources_connect = /** @type {((inputs?: Settings_Sources_ConnectInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sources_ConnectInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_sources_connect(inputs)
	return en_settings_sources_connect(inputs)
});
export { settings_sources_connect as "settings.sources.connect" }